import Mutations from '../../odata/mutations';

export default { ...new Mutations('approvalRequest'), ...new Mutations('approvalRequests') };
